import React, { useEffect } from "react";
import {Routes,Route} from "react-router-dom"
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import About from "./components/Pages/About/About";
import WorkDetail from "./components/Pages/WorkDetail/WorkDetail";
import Portfolio from "./components/Portfolio/Portfolio";
import Contact from "./components/Pages/Contact/Contact";
import Blog from "./components/Pages/Blog/Blog";
import Home from "./components/Pages/Home/Home/Home";
import AOS from "aos"
import 'aos/dist/aos.css'



function App() {
  
useEffect(()=>{
  AOS.init({duration:"2000"})
},[])

  return (
    <div>
        <Navbar />
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/about" element={<About/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>
        <Route path="/blog" element={<Blog/>}></Route>
        <Route path="/portfolio" element={<Portfolio/>}></Route>
        <Route path="/workDetail" element={<WorkDetail/>}></Route>
      </Routes>
      <Footer/>
      <ToastContainer/>
    </div>
  );
}

export default App;
